module.exports = __webpack_public_path__ + "static/media/1-min.f3701488.png";